/**
 * Mandate App — transition governance + embedded Individual Space platform surfaces.
 *
 * An app since roadmap S-16: its route family is /apps/mandate, behind its own
 * module, flag and entitlement (registry entry 'mandate'). The old /mandate
 * address redirects here (App.tsx, DEP-045).
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import MandateLayout from '../../components/mandate/MandateLayout';
import MandateDashboard from './MandateDashboard';
import MandateSetup from './MandateSetup';
import MandateOutcome from './MandateOutcome';
import MandatePrioritiesStack from './MandatePrioritiesStack';
import MandateDecisionRecord from './MandateDecisionRecord';
import MandateStakeholders from './MandateStakeholders';
import MandateSituation from './MandateSituation';
import MandateRecord from './MandateRecord';
import { mandatePlatformRouteElements } from './MandatePlatformRoutes';
import { getAppDefinition } from '../../apps/registry';
import { RequireAppAccess } from '../../apps/RequireAppAccess';

export default function MandateApp() {
  const app = getAppDefinition('mandate')!;
  return (
    <RequireAppAccess app={app}>
      <MandateLayout>
        <Routes>
          <Route index element={<Navigate to="/apps/mandate/dashboard" replace />} />
          <Route path="dashboard" element={<MandateDashboard />} />
          <Route path="setup" element={<MandateSetup />} />
          <Route path="outcome" element={<MandateOutcome />} />
          <Route path="priorities" element={<MandatePrioritiesStack />} />
          <Route path="decisions" element={<MandateDecisionRecord />} />
          <Route path="stakeholders" element={<MandateStakeholders />} />
          <Route path="situation" element={<MandateSituation />} />
          <Route path="record" element={<MandateRecord />} />

          {mandatePlatformRouteElements}

          <Route path="*" element={<Navigate to="/apps/mandate/dashboard" replace />} />
        </Routes>
      </MandateLayout>
    </RequireAppAccess>
  );
}
